import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiMembers: ApiType = {
  delete: {},
  post: {
    signup: ({ data }) => api.post('/api/members', data),
    verifyOTP: ({ data, vars }) =>
      api.post(stringParse('/api/members/{0}/verification/otp', vars), data),
  },
  put: {},
  get: {},
};
